export default __webpack_public_path__ + "img/26e2717e8e64b06e11089e124d2c0858.svg";